import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { PMOrderOperation } from 'src/app/models/domain';
import { YPMORDERSRVOperation } from 'src/generated-clients/order';

@Injectable({
  providedIn: 'root',
})
export class PMOperationAdapter implements IAdapter<PMOrderOperation, YPMORDERSRVOperation> {
  public adaptToDomain(sapResponse: YPMORDERSRVOperation): PMOrderOperation {
    return new PMOrderOperation(
      fallbackString(sapResponse.orderNumber),
      fallbackString(sapResponse.activityNumber),
      fallbackString(sapResponse.workCenter),
      fallbackString(sapResponse.plant),
      fallbackString(sapResponse.workCenterDescription),
      fallbackString(sapResponse.operationShortText),
      fallbackString(sapResponse.internalExternalProcessing),
      fallbackString(sapResponse.vendorNumber),
      fallbackString(sapResponse.vendorName),
      fallbackString(sapResponse.durationOfActivity),
      fallbackString(sapResponse.durationOfActivityUnit),
      fallbackString(sapResponse.objectNumber),
      fallbackString(sapResponse.systemStatus),
      fallbackString(sapResponse.changeDate),
      fallbackString(sapResponse.changeTime),
      fallbackDate(sapResponse.earliestStartExecutionDate),
      fallbackDate(sapResponse.earliestFinishExecutionDate),
      fallbackDate(sapResponse.latestStartExecutionDate),
      fallbackDate(sapResponse.latestFinishExecutionDate),
      fallbackString(sapResponse.constraintTypeStart),
      fallbackDate(sapResponse.constraintStartDate),
      fallbackString(sapResponse.constraintTypeEnd),
      fallbackDate(sapResponse.constraintEndDate),
      fallbackDate(sapResponse.actualStartExecutionDate),
      fallbackDate(sapResponse.actualFinishExecutionDate),
      fallbackDate(sapResponse.forecastFinishDate),
      fallbackDate(sapResponse.userDate09)
    );
  }
}
